import React from 'react';
import { Trophy, Plus, Edit2, Trash2 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Avatar } from '../../components/ui/Avatar';
import { Badge } from '../../components/ui/Badge';
export function HallOfFameAdmin() {
  return <div className="space-y-6" data-id="element-275">
      <div className="flex justify-between items-center" data-id="element-276">
        <div data-id="element-277">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-278">
            Gerenciar Hall da Fama
          </h1>
          <p className="text-gray-500" data-id="element-279">Reconheça os alunos destaque do mês.</p>
        </div>
        <Button leftIcon={<Plus size={18} data-id="element-281" />} data-id="element-280">Nova Categoria</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-282">
        {/* Category Card 1 */}
        <Card className="relative group" data-id="element-283">
          <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity flex gap-2" data-id="element-284">
            <button className="p-1.5 bg-white shadow-sm rounded-md text-gray-500 hover:text-[var(--primary)]" data-id="element-285">
              <Edit2 size={16} data-id="element-286" />
            </button>
          </div>

          <div className="flex items-center gap-3 mb-6" data-id="element-287">
            <div className="p-3 bg-blue-100 text-blue-600 rounded-lg" data-id="element-288">
              <Trophy size={24} data-id="element-289" />
            </div>
            <div data-id="element-290">
              <h3 className="font-bold text-gray-900" data-id="element-291">Constância</h3>
              <Badge variant="success" data-id="element-292">Ativo</Badge>
            </div>
          </div>

          <div className="space-y-3" data-id="element-293">
            <p className="text-xs font-bold text-gray-500 uppercase" data-id="element-294">
              Vencedores Atuais
            </p>
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg" data-id="element-295">
              <div className="flex items-center gap-2" data-id="element-296">
                <span className="font-bold text-gray-400 w-4" data-id="element-297">1</span>
                <Avatar size="sm" alt="Mariana" data-id="element-298" />
                <span className="text-sm font-medium" data-id="element-299">Mariana Costa</span>
              </div>
              <span className="text-xs font-bold text-blue-600" data-id="element-300">28 dias</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg" data-id="element-301">
              <div className="flex items-center gap-2" data-id="element-302">
                <span className="font-bold text-gray-400 w-4" data-id="element-303">2</span>
                <Avatar size="sm" alt="João" fallback="?" data-id="element-304" />
                <span className="text-sm font-medium" data-id="element-305">João Silva</span>
              </div>
              <span className="text-xs font-bold text-blue-600" data-id="element-306">26 dias</span>
            </div>
          </div>

          <Button variant="outline" size="sm" className="w-full mt-4" data-id="element-307">
            Editar Vencedores
          </Button>
        </Card>

        {/* Category Card 2 */}
        <Card className="relative group" data-id="element-308">
          <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity flex gap-2" data-id="element-309">
            <button className="p-1.5 bg-white shadow-sm rounded-md text-gray-500 hover:text-[var(--primary)]" data-id="element-310">
              <Edit2 size={16} data-id="element-311" />
            </button>
          </div>

          <div className="flex items-center gap-3 mb-6" data-id="element-312">
            <div className="p-3 bg-green-100 text-green-600 rounded-lg" data-id="element-313">
              <Trophy size={24} data-id="element-314" />
            </div>
            <div data-id="element-315">
              <h3 className="font-bold text-gray-900" data-id="element-316">Evolução</h3>
              <Badge variant="success" data-id="element-317">Ativo</Badge>
            </div>
          </div>

          <div className="space-y-3" data-id="element-318">
            <p className="text-xs font-bold text-gray-500 uppercase" data-id="element-319">
              Vencedores Atuais
            </p>
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg" data-id="element-320">
              <div className="flex items-center gap-2" data-id="element-321">
                <span className="font-bold text-gray-400 w-4" data-id="element-322">1</span>
                <Avatar size="sm" alt="Pedro" data-id="element-323" />
                <span className="text-sm font-medium" data-id="element-324">Pedro Santos</span>
              </div>
              <span className="text-xs font-bold text-green-600" data-id="element-325">
                +15% Carga
              </span>
            </div>
          </div>

          <Button variant="outline" size="sm" className="w-full mt-4" data-id="element-326">
            Editar Vencedores
          </Button>
        </Card>
      </div>
    </div>;
}